module.exports = __webpack_public_path__ + "img/gal_2.214853e4.png";